import React from 'react';
import { IconProps } from '.';

const SvgTune = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M10.905 8.75a3.001 3.001 0 0 1-5.81 0H1v-1.5h4.095a3.001 3.001 0 0 1 5.81 0H23v1.5H10.905ZM9.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM1 16.75h12.095a3.001 3.001 0 0 0 5.81 0H23v-1.5h-4.095a3.001 3.001 0 0 0-5.81 0H1v1.5Zm15 .75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgTune;
